import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api.js';
import { t, huidigeTaal } from '../i18n.js';
import { DIENSTEN, NIS2 } from '../beveiligingsstatus.js';

/**
 * Beheer › Klanten › Diensten (docs/ontwerp/beveiligingsstatus.md): of de klant onder NIS2 valt, en welke diensten van
 * ADTS buiten ZERO hij afneemt, met de hand tot ze uit het portaal of ADTS-ONE komen. De ZERO-modules staan onder
 * Modules; DNS en Endpoint Security tellen ook als de module van Umbrella of Secure Endpoint aan staat.
 */
const taal = (x) => x?.[huidigeTaal()] ?? x?.nl ?? '';

export default function KlantDiensten({ klant }) {
  const q = useQuery({ queryKey: ['klant-diensten', klant.code], queryFn: () => api.klantDiensten(klant.code) });
  const [melding, zetMelding] = useState(null);
  const [bezig, zetBezig] = useState(false);
  const zet = async (invoer) => {
    zetMelding(null); zetBezig(true);
    try { await api.zetKlantDiensten(klant.code, invoer); } catch (e) { zetMelding(t(e.message)); } finally { zetBezig(false); q.refetch(); }
  };
  if (q.isPending) return <p className="muted">{t('Laden…')}</p>;
  if (q.isError) return <div className="melder rood">{t(q.error.message)}</div>;
  const { nis2, services } = q.data.data;
  return (
    <div>
      {melding && <div className="melder rood" style={{ marginBottom: 10 }}>{melding}</div>}
      <p className="muted">{t('Voor de beveiligingsstatus en de security score. Met de hand, tot de contracten uit het klantportaal of ADTS-ONE komen.')}</p>
      <label className="field" style={{ maxWidth: 360, marginBottom: 14 }}><span>NIS2</span>
        <select className="input" value={nis2 ?? ''} disabled={bezig} onChange={(e) => zet({ nis2: e.target.value || null })}>
          <option value="">{t('Nog niet bekend')}</option>
          {NIS2.map((n) => <option key={n.id} value={n.id}>{taal(n.tekst)}</option>)}
        </select>
      </label>
      <div className="bs-diensten">
        {services.map((s) => {
          const x = DIENSTEN.find((d) => d.id === s.id);
          return (
            <label key={s.id} className={`bs-dienst${s.taken || s.viaModule ? '' : ' nee'}`} style={{ cursor: 'pointer' }}>
              <span className="naam"><input type="checkbox" checked={s.taken} disabled={bezig} onChange={(e) => zet({ services: { [s.id]: e.target.checked } })} /> {taal(x?.naam)}</span>
              <span className="wat" style={{ display: 'block' }}>{x?.groep}</span>
              {s.viaModule && <span className="stand ja" style={{ display: 'block' }}>✓ {t('Telt al mee via de module')}</span>}
            </label>
          );
        })}
      </div>
    </div>
  );
}
